import { useGateValue } from '@coursera-web/statsig';

import { PERSONALIZATION_SETTINGS_GATE } from 'bundles/personalization-settings/constants';

/**
 * Whether the Personalization settings tab is enabled for the current user.
 *
 * Wraps the `personalised_settings_page` Statsig gate so consumers (the
 * account-settings mount site) call a named, unit-tested bundle hook rather
 * than `useGateValue` directly. Dark-launched — the gate defaults OFF until
 * rollout.
 */
export const useIsPersonalizationSettingsEnabled = (): boolean => useGateValue(PERSONALIZATION_SETTINGS_GATE);
